import { Redirect, Route, RouteProps } from 'react-router-dom';
import { loginRoute, migrateFromEngage } from '.';
import AuthRequestStatus from '../enums/AuthRequestStatus';
import { AuthRoutesState } from '../types/AuthRoutesState';

interface Props extends RouteProps {
    authRoutesState: AuthRoutesState;
}

//this should ONLY be used for absolute basic "isLoggedIn" checks ie: for sic activation
export default function NoSicRoute({ authRoutesState, children, ...rest }: Props) {
    return (
        <Route
            {...rest}
            render={({ location }) => {
                if (authRoutesState.requestStatus === AuthRequestStatus.configSuccess) {
                    //sic not active for client
                    if (!authRoutesState.clientHasSic) {
                        return <>{children}</>;
                    }

                    //migrate/activate sic screen
                    if (
                        authRoutesState.dialerIsEnabled &&
                        authRoutesState.dialerIsSic &&
                        !authRoutesState.dialerIsSetup
                    ) {
                        return (
                            <Redirect
                                to={{ pathname: migrateFromEngage, state: { from: location } }}
                            />
                        );
                    }

                    return <Redirect to={{ pathname: '/', state: { from: location } }} />;
                } else {
                    //just show them the login screen
                    return <Redirect to={{ pathname: loginRoute, state: { from: location } }} />;
                }
            }}
        />
    );
}
